import { render } from "./MeasurementsSection.vue?vue&type=template&id=3e91891e&scoped=true"
import script from "./MeasurementsSection.vue?vue&type=script&lang=js"
export * from "./MeasurementsSection.vue?vue&type=script&lang=js"

import "./MeasurementsSection.vue?vue&type=style&index=0&id=3e91891e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e91891e"]])

export default __exports__